<template>
  <div id="app">
      <HorizontalNavbar />
    <router-view />
    <FloatingWhatsApp />
    <FooterSection />
  </div>
</template>

<script setup>
import FooterSection from './components/FooterSection.vue'
import HorizontalNavbar from './components/HorizontalNavbar.vue'
import FloatingWhatsApp from './components/FloatingWhatsApp.vue'
</script>

<style scoped>
mark {
  color: #000;
  background: rgb(255, 149, 0) !important;
}


#hero-section h2,
.eshowtxt,
.videtxt,
body,
ol.tree li a,
ol.tree li label {
  font-weight: 300
}

.generic .card-body-section h2,
.generic .card-body-section p a,
.generic .card-info,
.generic .card-info-amt {
  text-overflow: ellipsis;
  overflow: hidden
}

.section-ptb h2::after {
  content: "";
  display: block;
  width: 67px;
  height: 1px;
  border-radius: 0;
  background: #ed1c24;
  margin: 11px 0 21px;

}

.section-ptb h2 {
  font-size: 26px;
  font-weight: 700
}

.trending-franchise-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap
}

.generic .card {
  height: 323px;
  width: 24%;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 4px;
  padding: 12px 15px !important;
  margin-bottom: 0;
  margin-top: 15px
}

#search,
.generic .card-body-section {
  padding-top: 2px
}

.brand-image-section {
  border: 1px solid #e5e5e5;
  background-color: #fafafa;
  border-radius: 4px;
  text-align: center;
  overflow: hidden;
  position: relative;
  display: table;
  width: 100%;
  height: 128px
}

.brand-main-section {
  display: table-cell;
  vertical-align: middle
}

.generic .card-body-section p {
  font-weight: 300;
  font-size: 12px;
  margin: 5px 0 0;
  color: #828282;
  text-overflow: ellipsis
}

.generic .card-body-section p a {
  white-space: nowrap
}

.generic .card-info {
  width: 60%;
  font-size: 13px;
  white-space: nowrap
}

.generic .card-info-amt {
  width: 40%;
  text-align: right;
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap
}

.generic .link-section {
  color: #ff6b35;
  border: 1px solid #ff6b35;
  padding: 5px;
  border-radius: 4px;
  margin-top: 10px
}

.generic .card-body-section h2 {
  font-size: 14px;
  line-height: 19px;
  margin-top: 9px;
  margin-bottom: 9px;
  font-weight: 600;
  white-space: nowrap;
  width: 100%
}

.covidproof .card {
  height: 310px;
  width: 24%
}

@media screen and (max-width:768px) {
  .trending-franchise-wrap {
    padding-bottom: 15px;
    display: block;
    overflow: auto;
    white-space: nowrap;
    padding-left: 2px
  }

  .section-ptb h2 {
    font-size: 18px
  }

  .brand-img {
    border: 1px solid #e5e5e5;
    background-color: #fafafa;
    border-radius: 4px;
    text-align: center;
    overflow: hidden;
    position: relative;
    display: table;
    width: 100%;
    height: 128px
  }

  .covidproof .card {
    height: 310px;
    margin-right: 10px;
    margin-top: 0;
    display: inline-block;
    width: 250px
  }
}

.hero-mobile,
.mmdesk,
.smobile,
.top-investor-mobile {
  display: none
}

li.top-investors {
  height: 20px
}

#btnhome,
.business-a,
.hero-desktop,
.policydropdown:hover .policydropdownmenu,
.ppdesk,
.radio,
.smallimp,
a.setpat {
  display: block
}

#main {
  margin-top: -100px
}

.about-us {
  padding-top: 30px
}

#hero-section {
  margin-top: 0 !important;
  color: #fff;
  padding: 0;
  position: relative;
}

#hero-section .banner-expo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
  height: 440px
}

.lnkblk {
  width: 300px;
  float: right;
  top: -43px;
  position: relative;
  z-index: 1
}

.lnkblk {
  text-align: right;
}

#hero-section h1 {
  color: #fff;
  margin-top: -114px;
  font-size: 33px;
  margin-bottom: 6px
}

#hero-section h1 span {
  color: #ff0
}

#hero-section h2 {
  font-size: 25px;
  color: #fff;
  z-index: 8;
  text-shadow: 2px 2px 8px #4c482f;
  margin: 5px 0 30px
}

.nav>li>a:hover {
  background-color: #fff;
  color: #000;
  border-radius: 0
}

.btn-main,
.btn-main:focus,
.btn-main:hover {
  color: #fff
}

.nav-tabs>li.active>a,
.nav-tabs>li.active>a:focus,
.nav-tabs>li.active>a:hover {
  color: #fff;
  cursor: default;
  background-color: rgba(237, 28, 36, .6);
  border: 0 solid rgba(237, 28, 36, .6);
  border-radius: 0 !important;
  padding: 10px 15px !important;
  margin-left: 1px
}

.tab-content .tab-pane.active {
  transform: translateY(-1px);
  opacity: 1;
  -webkit-animation: .8s forwards fadeUp;
  -moz-animation: .8s forwards fadeUp;
  -o-animation: .8s forwards fadeUp;
  animation: .8s forwards fadeUp
}

.tab-content .tab-pane {
  opacity: 0;
  transition: opacity .8s linear
}


.m-0 {
  margin: 0
}

ul.hero-search-main li select {
  width: 356px !important
}

/* .dropdown-toogle-icon {
  -webkit-appearance: none;
  background: url(https://www.franchiseindia.com/images/drop-down-icon.png) 95% center no-repeat #fff !important
} */

.form-control {
  border: 0 solid #ccc
}

.form-control-custom {
  height: 46px !important;
  padding: .6rem 7.9rem !important;
  border-radius: 0 !important
}

.btn-main-hero {
  width: 60px;
  font-size: 13px;
  line-height: 1;
  height: 47px !important
}

.btn-main {
  border-color: #ed1c24;
  border-radius: 0;
  outline: 0;
  color: #fff;
  background-color: #ed1c24
}

@media only screen and (min-width:993px) and (max-width:1199px) {
  .covidproof .card {
    height: 310px;
    width: 24.3%;
    padding: 10px !important
  }

  #hero-section h1 {
    margin-top: -98px !important;
    font-size: 27px !important
  }

  #hero-section h2 {
    font-size: 23px
  }
}

@media only screen and (min-width:769px) and (max-width:992px) {
  .lnkblk {
    text-align: right;
  }

  .covidproof .card,
  .generic .card {
    width: 49% !important
  }

  .p-30 {
    padding-right: 0 !important;
    padding-left: 0 !important
  }
  #hero-section h1 {
    font-size: 24px !important;
    margin-top: 0 !important
  }

  #hero-section h2 {
    font-size: 19px !important
  }

  .section-ptb a {
    top: 0 !important
  }

  .lnkblk a {
    top: -26 !important
  }


  .logo {
    padding-left: 118px !important
  }

  #card-section h4,
  .form-ask-experts {
    margin-top: 10px
  }

  .business-a {
    position: relative;
    z-index: 2;
    margin-bottom: 15px
  }

  .section-ptb h2 {
    font-size: 22px !important;
    margin-bottom: -10px !important
  }
}

body {
  font-family: Roboto, sans-serif;
  background: #f1f1f1
}

.generic .link-section a:hover {
  color: #ff6b35;
  text-decoration: none
}

a {
  color: inherit
}

#header {
  padding: 0;
  width: 100%;
  position: fixed;
  z-index: 5;
  top: 0
}

.topbar {
  background-color: #f5f5f5
}

.p-2 {
  padding: .5rem !important
}

.top-navigation,
ul.login-main-section {
  margin-bottom: 0;
  padding-inline-start: 0;
  list-style: none
}

ul.top-navigation {
  display: inline-flex;
  margin-top: 3px
}

ul.top-navigation li a {
  color: #101010
}

.top-navigation {
  font-size: 13px
}

.input-group-prepend-custom {
  padding: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: rgb(238 238 238 / 0%);
  border-radius: 0
}

.input-group-prepend-custom img {
  width: 15px
}

select#language-changer {
  height: 27px !important;
  padding: 3px !important;
  font-size: 13px
}

.form-control-custom-main {
  line-height: 1.2
}

ul.top-navigation li::after {
  content: "|";
  padding: 0 5px
}

.ml-auto,
.mx-auto {
  margin-left: auto !important
}

.d-flex {
  display: flex
}

.header-btm {
  padding-top: 20px;
  background: #fff;
  padding-bottom: 15px
}

.p-30 {
  padding-right: 24px;
  padding-left: 24px
}

.logo {
  display: block;
  margin: 0 auto;
  padding-left: 175px
}

.d-main,
ul.login-main-section li,
ul.sidebar-social li {
  display: inline-flex
}

#search {
  padding-right: 16px
}

.login-text-right img,
.search img {
  width: 25px;
  height: 25px
}

.search span {
  margin-left: 7px
}

.login-text-right {
  padding-top: 5px
}

ul.login-main-section {
  margin-top: 4px;
  margin-left: 10px
}

ul.fihl-loaction-browse li:last-child::after,
ul.login-main-section li:last-child::after,
ul.top-navigation li:last-child::after {
  content: ""
}

.overlay.active {
  display: block;
  opacity: 1;
  width: 100%;
  height: 119%;
  margin-top: -21px
}

.overlay {
  display: none;
  width: 100vw;
  background: rgba(0, 0, 0, .7);
  z-index: 998;
  opacity: 0;
  transition: .5s ease-in-out;
  top: 0
}

.overlay {
  position: fixed;
  height: 100vh
}

.pt-35 {
  padding-top: 35px !important
}


.martop {
  margin-top: 10px
}

.section-30 {
  padding-bottom: 30px
}

.card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 4px;
  padding: 12px 15px !important;
  margin-bottom: 15px;
  margin-top: 15px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgb(237 28 36 / 20%)
}


#btnhome {
  margin: auto
}


.pt-30 {
  padding-top: 30px !important
}

h4 {
  font-size: 18px
}

@media screen and (max-width:768px) {


  #hero-search,
  .lnkblk {
    clear: both
  }

  .hero-mobile,
  .mmdesk,
  .policydropdown:hover .policydropdownmenu,
  .smobile {
    display: block
  }
  
  #card-section,
  .hero-desktop,
  .menu-bar span,
  .ppdesk,
  .search span,
  .tab-content .search-icon,
  .topbar,
  ul.login-main-section {
    display: none
  }

  .lnkblk img {
    width: 237px;
    height: 60px
  }

  #main {
    margin-top: 20px
  }

  #hero-section {
    margin-top: 62px;
    padding-bottom: 50px
  }

  .lnkblk {
    width: 237px;
    float: right;
    overflow: hidden;
    margin-bottom: 20px;
    position: absolute;
    z-index: 1;
    margin-top: 46px;
    top: 0;
    right: 0
  }

  #hero-section h2 {
    font-size: 17px;
    line-height: 23px;
    font-weight: 400 !important;
    text-align: center;
    margin-bottom: 30px;
    color: #fff;
    text-shadow: 2px 2px 8px #4c482f
  }

  #hero-section h1 {
    color: #fff;
    text-align: center;
    margin-top: 0;
    font-size: 23px;
    clear: both;
    line-height: 34px
  }

  .hero-search .tab-content {
    background: rgba(255, 255, 255, .7);
    padding: 20px
  }

  ul.hero-search-main li {
    display: block;
    margin-bottom: 15px
  }

  .hero-search .form-control-custom {
    padding: 8px 10px 7px !important
  }

  ul.hero-search-main li select {
    width: 100% !important
  }

  .btn-main-hero {
    width: 100%;
    font-size: 16px;
    line-height: 1;
    height: 47px !important;
    color: #fff;
    background-color: #ed1c24;
    border-color: #ed1c24;
    outline: 0;
    border-radius: 0
  }

  #header {
    padding: 10px 0;
    width: 100%;
    background: #fff;
    position: fixed;
    z-index: 998;
    top: 0
  }

  .m-align {
    align-items: baseline
  }

  .logo img {
    width: 200px;
    padding-top: 3px
  }

  .m-search {
    margin-left: auto
  }

  .login-text-right img,
  .search img {
    width: 22px;
    height: 24px
  }

  .header-btm {
    padding-top: 5px;
    padding-bottom: 0
  }

  .p-2 {
    padding: .5rem !important
  }

  .p-30 {
    padding-right: 0;
    padding-left: 0
  }

  .logo {
    margin: 0 0 0 4px;
    padding: 0
  }
}
</style>
